<div class="angular-date-picker"
    [ngClass]="{ 'date-picker-small': small, '-disabled': disabled }">
    <div class="_month">
        <button type="button" class="_previous" [disabled]="disabled" (click)="!disabled && changeMonthBy(-1)">
            &laquo;
        </button>
        <span>
            {{ getMonthName(currentMonth) }}
            <ng-container *ngIf="showYear"> {{ currentYear }}</ng-container>
        </span>
        <button type="button" class="_next" [disabled]="disabled" (click)="!disabled && changeMonthBy(1)">
            &raquo;
        </button>
    </div>
    <div class="_days">
        <div class="_day-of-week"
             *ngFor="let day of getDaysName()">{{ day[0] }}
        </div>
        <div *ngFor="let week of weeks">
            <div *ngFor="let dayObj of week; let idx = index"
                 class="_day"
                 [ngClass]="{ '-selected': (dayObj.day === selectedDay && dayObj.currentMonth),
                '-today': (dayObj.day === today && dayObj.currentMonth
                    && currentMonth === date.getMonth()
                    && currentYear === date.getFullYear()),
                '-padding': !dayObj.currentMonth }"
                    [attr.data-testid]="'day-' + dayObj.day"
                 (click)="!disabled && selectDay(dayObj.day, dayObj.currentMonth)">
                {{ dayObj.day }}
            </div>
        </div>
    </div>
</div>
